import { useFormikSubmit } from "@certn/api";
import {
  GhostIconButton,
  TextAreaFormikField,
  useColors,
} from "@certn/cascadia-react";
import { css } from "@emotion/css";
import { Form, Formik } from "formik";
import { t } from "i18next";
import { useParams } from "react-router-dom";

interface props {
  mutate: any;
}

export function LegacyCommentForm(props: props) {
  const { mutate } = props;
  const colors = useColors();
  const { reportId } = useParams();

  const { submit } = useFormikSubmit(
    `/api/internal/client-portal/legacy-case-comments/create/`,
    {
      throwErrors: true,
      showToastOnError: true,
      resetOnSuccess: true,
      onSuccess: () => {
        mutate();
      },
    }
  );

  const initialValues = {
    message: "",
    legacy_case_report_id: reportId,
  };

  return (
    <Formik initialValues={initialValues} onSubmit={submit}>
      {({ isSubmitting }) => {
        return (
          <Form
            className={css(styles.form, {
              borderTop: `1px solid ${colors["border-base"]}`,
            })}
          >
            <TextAreaFormikField
              isDisabled={true}
              label=""
              aria-label="add-legacy-comment-input-field"
              name="message"
              isRequired
              testID="add-legacy-comment-text-input-field"
              placeholder={t("Disabled for historic cases")}
              resize="vertical"
              className={styles.textField}
              minHeight={40}
            />
            <GhostIconButton
              isDisabled={true}
              type="submit"
              size="small"
              testID="save-legacy-comment-button"
              icon="send"
              isLoading={isSubmitting}
            >
              {t("Save")}
            </GhostIconButton>
          </Form>
        );
      }}
    </Formik>
  );
}

const styles = {
  form: css({
    display: "flex",
    padding: `${"var(--space-3)"} ${"var(--space-3)"} ${"var(--space-3)"}`,
    flexDirection: "row",
    alignItems: "center",
    gap: "var(--space-2)",
  }),
  textField: css({
    width: "100%",
    maxHeight: "168px",
  }),
};
